import React from "react";
import { useState, useEffect } from "react";
import AuthService from "../services/auth.service";
import api from "../services/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import TopBar from "../components/TopBar";
function Vaccine() {
  const [vaccine, setVaccine] = useState({});
  const navigate = useNavigate();
  let { calfId, id } = useParams();
  const getVaccine = () => {
    api.get("/vaccine/" + id)
      .then((response) => {
        const data = response.data;
        setVaccine(data);
      })
      .catch((error) => {
        console.error("There was an error creating a calf!", error);
      });
  };
  const handleDelete = () => {
    api.delete("/vaccine/" + id)
      .then(() => {
        navigate("/veaux/" + calfId + "?view=vaccin");
      })
      .catch((error) => {
        console.error("There was an error creating a calf!", error);
      });
  };
  useEffect(() => {
    //Runs only on the first render
    const currentUser = AuthService.getCurrentUser();
    if (!currentUser) {
      navigate("/login");
    } else {
      getVaccine();
    }
  }, []);
  return (
    <div>
      <TopBar link={"/veaux/" + calfId + "?view=vaccin"}></TopBar>
      <div className="bg-white rounded-lg mt-3 mx-3 dark:bg-slate-800 dark:border-slate-700 dark:text-white">
        <div className="flex flex-col ml-3">
          <div className="flex justify-between items-center border-b dark:border-slate-700">
            <span className="py-2 text-sm">Date du vaccin</span>
            <span className="text-stone-400 text-sm mr-3">
              {new Date(vaccine.date).toLocaleString("default", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </span>
          </div>

          <div className="flex justify-between items-center dark:border-slate-700">
            <span className="py-2 text-sm">Nom</span>
            <span className="text-stone-400 text-sm mr-3">{vaccine.name}</span>
          </div>
        </div>
      </div>
      <div className="px-3 mt-3">
        <Link to={"/modifier_vaccin/" + calfId + "/" + id}>
          <button className="bg-amber-400 rounded-lg text-white shadow font-semibold py-2 w-full dark:bg-amber-600 dark:text-white">
            Modifier
          </button>
        </Link>
      </div>
      <div className="px-3 mt-3">
        <button
          className="bg-white rounded-lg text-red-500 shadow font-semibold py-2 w-full dark:bg-red-600 dark:text-white"
          onClick={() => handleDelete()}
        >
          Supprimer
        </button>
      </div>
    </div>
  );
}

export default Vaccine;
